import { FilterField } from "~/features/filter";

import {
  useDealerOptions,
  useRegMenUserOptions,
  useReportOptions,
} from "./optionsHooks";

type Translate = (key: string) => string;

/**
 * Поля фильтра страницы рег. менеджеров. Имена полей совпадают с именами
 * полей старой формы — они же источник query-переменных отчётов.
 * Набор полей зависит от выбранного типа отчёта (SelectReport), как в
 * старой форме: дилер — по дилеру, рег. менеджер — по рег. менеджеру,
 * у сводного отчёта параметров нет. Период отчёта «по периоду» задаётся
 * в PeriodFilter на самой странице, поэтому квартал/год сюда не добавляем.
 */
export const regMenFilterFields = (
  t: Translate,
  reportType: string,
): FilterField[] => {
  const fields: FilterField[] = [
    {
      name: "SelectReport",
      type: "select",
      label: t("regMen.reportType"),
      fixedWidth: 240,
      optionsHook: useReportOptions,
    },
  ];

  if (reportType === "reportDealer") {
    fields.push({
      name: "dealerIdFilter",
      type: "select",
      label: t("violationsTable.filterLabelDealership"),
      fixedWidth: 320,
      optionsHook: useDealerOptions,
    });
  }

  if (reportType === "reportRegMen") {
    fields.push({
      name: "userIdFilter",
      type: "select",
      label: t("users.regional_manager"),
      fixedWidth: 320,
      optionsHook: useRegMenUserOptions,
    });
  }

  return fields;
};
